import React, { Component } from 'react'
import Spacer from '../../../components/spacer'
import JewelryPanel from '../jewelry-panel'
import PrimaryDiamondShapes from '../../select-shapes/shapes'
import SelectShapes from '../../../components/select-shapes'
import SelectItem from '../../../components/select-item'
import CaratSlider from './carat-slider'
import {showPrimaryDiamondPanel} from '../../../utils/jewelry-validation'

class PrimaryDiamondPanel extends Component {
  render () {
    return (
      <JewelryPanel
        id='primaryDiamondPanel'
        show={showPrimaryDiamondPanel(this.props)}
        isResetting={this.props.isResetting}>

        <Spacer lg />

        <h4 id='diamondshape'>Primary Diamond Shape</h4>
        <SelectShapes
          id='primary_diamond_shape'
          single
          listFor={'primary_diamond'}
          value={this.props.shapes}
          onChange={this.props.onChangeVal.bind(this, 'shapes')}
          shapes={PrimaryDiamondShapes}
          initVal={[]}
        />

        <div id='primary_diamond_detail_section'>
          <SelectItem
            id='primary_diamond_colour'
            label='Primary Diamond Colour'
            labelId='primary_diamond_colour'
            options={[
              {value: 'd', label: 'D'},
              {value: 'e', label: 'E'},
              {value: 'f', label: 'F'},
              {value: 'g', label: 'G'},
              {value: 'h', label: 'H'},
              {value: 'i', label: 'I'},
              {value: 'default_other', label: 'N/A'}
            ]}
            value={this.props.colour}
            onChange={this.props.onChangeVal.bind(this, 'colour')}
            initVal={'default_other'}
          />

          <Spacer xxs />

          <CaratSlider
            id='primary_diamond_size'
            label='Primary Diamond Size'
            sliderId='primary_diamond_size'
            single
            input
            labelRight='ct'
            min={0.01}
            max={5.00}
            step={0.01}
            value={this.props.primary_diamond_size}
            onChange={this.props.onChangeVal.bind(this, 'primary_diamond_size')}
            initVal={1.0}
          />
        </div>
      </JewelryPanel>
    )
  }
}

export default PrimaryDiamondPanel



// WEBPACK FOOTER //
// ./src/components/jewelry-search-filters/primary-diamond-panel/index.js